'use strict';

var _classCallCheck = require("/Users/andrejgoncarenko/WebstormProjects/knackly/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/andrejgoncarenko/WebstormProjects/knackly/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var Scope = require('./yobj');
var IndirectVirtual = require('./indirect');
var OD = require('./fieldtypes');
var base = require('./base-templater');
var TextEvaluator = /*#__PURE__*/function () {
  function TextEvaluator(scope) {
    _classCallCheck(this, TextEvaluator);
    this.missing = {};
    this.errors = [];
    this.contextStack = scope && scope.__yobj ? scope.__yobj : scope instanceof Scope ? scope : Scope.pushObject(scope);
  }
  _createClass(TextEvaluator, [{
    key: "assemble",
    value: function assemble(contentArray) {
      var _this = this;
      var textItems = contentArray.map(function (contentItem) {
        return _this.ContentReplacementTransform(contentItem, _this.contextStack);
      });
      // reset context stack (a TextEvaluator is a one-time-use sort of thing)
      this.contextStack = null;
      return textItems.join('');
    }
  }, {
    key: "ContentReplacementTransform",
    value: function ContentReplacementTransform(contentItem, contextStack) {
      var _this2 = this;
      if (!contentItem) {
        return '';
      }
      if (typeof contentItem === 'string') {
        return contentItem;
      }
      if (typeof contentItem !== 'object') {
        throw new Error("Unexpected content '".concat(contentItem, "'"));
      }
      var frame = contextStack; // .peek()
      switch (contentItem.type) {
        case OD.Content:
          try {
            var evaluator = base.compileExpr(contentItem.expr); // these are cached so this should be fast
            // todo: make sure the following is memoized to avoid unnecessary re-evaluation
            var value = frame.evaluate(evaluator);
            if (value === null || typeof value === 'undefined') {
              this.missing[contentItem.expr] = true;
              value = this.missingValuePlaceholder(contentItem.expr);
            } else if (typeof value === 'object') {
              // if (value.__value) {
              //   value = value.valueOf()
              // }
              if (value instanceof IndirectVirtual || value.__value instanceof IndirectVirtual) {
                if (value.toString !== Object.toString) {
                  var strVal = value.toString();
                  if (strVal !== '[object Object]') {
                    // not helpful
                    value = strVal;
                  }
                }
                if (typeof value !== 'string') {
                  this.errors.push("Template '".concat(contentItem.expr, "' (").concat(value.contentType || typeof value, ") cannot be assembled as text"));
                  value = this.missingValuePlaceholder(contentItem.expr);
                }
              } else if (value.errors || value.missing) {
                // value is a yatte EvaluationResult, probably because of nested template evaluation
                if (value.missing && value.missing.length > 0) {
                  value.missing.forEach(function (expr) {
                    _this2.missing[expr] = true;
                  });
                }
                if (value.errors && value.errors.length > 0) {
                  value.errors.forEach(function (errmsg) {
                    _this2.errors.push(errmsg);
                  });
                }
                value = value.valueOf(); // get the actual evaluated value
              }
            }

            return value;
          } catch (err) {
            return CreateContextErrorMessage('EvaluationException: ' + err.message);
          }
        case OD.List:
          {
            var iterable;
            try {
              var _evaluator = base.compileExpr(contentItem.expr); // these are cached so this should be fast
              // todo: make sure the following is memoized to avoid unnecessary re-evaluation
              iterable = frame.evaluate(_evaluator);
            } catch (err) {
              return CreateContextErrorMessage('EvaluationException: ' + err.message);
            }
            contextStack = Scope.pushList(iterable, contextStack);
            var allContent = contextStack.indices.map(function (index) {
              contextStack = Scope.pushListItem(index, contextStack);
              var listItemContent = contentItem.contentArray.map(function (listContentItem) {
                return _this2.ContentReplacementTransform(listContentItem, contextStack);
              });
              contextStack = Scope.pop(contextStack);
              return listItemContent.join('');
            });
            contextStack = Scope.pop(contextStack);
            return allContent.join('');
          }
        case OD.If:
        case OD.ElseIf:
          {
            var bValue;
            try {
              if (frame.frameType === Scope.LIST) {
                throw new Error("Internal error: cannot define a condition directly in a ".concat(frame.frameType, " context"));
              }
              var _evaluator2 = base.compileExpr(contentItem.expr); // these are cached so this should be fast
              // todo: make sure the following is memoized to avoid unnecessary re-evaluation
              var _value = frame.evaluate(_evaluator2);
              bValue = Scope.isTruthy(_value);
            } catch (err) {
              return CreateContextErrorMessage('EvaluationException: ' + err.message);
            }
            if (bValue) {
              var content = contentItem.contentArray.filter(function (item) {
                return typeof item !== 'object' || item == null || item.type !== OD.ElseIf && item.type !== OD.Else;
              }).map(function (conditionalContentItem) {
                return _this2.ContentReplacementTransform(conditionalContentItem, contextStack);
              });
              return content.join('');
            }
            var elseCond = contentItem.contentArray.find(function (item) {
              return typeof item === 'object' && item != null && (item.type === OD.ElseIf || item.type === OD.Else);
            });
            if (elseCond) {
              if (elseCond.type === OD.ElseIf) {
                return this.ContentReplacementTransform(elseCond, contextStack);
              }
              // else
              var _content = elseCond.contentArray.map(function (conditionalContentItem) {
                return _this2.ContentReplacementTransform(conditionalContentItem, contextStack);
              });
              return _content.join('');
            }
            return '';
          }
      }
    }
  }, {
    key: "missingValuePlaceholder",
    value: function missingValuePlaceholder(expr) {
      if (expr.includes('|')) {
        var ast = base.compileExpr(expr).ast;
        if (ast.type === base.AST.AngularFilterExpression) {
          return this.missingValuePlaceholder(base.serializeAST(ast.input));
        }
      }
      return '[' + expr + ']';
    }
  }]);
  return TextEvaluator;
}();
module.exports = TextEvaluator;
function CreateContextErrorMessage(message) {
  return '*** ' + message + ' ***';
}